import Documents from "@/pages/medewerkers/$userId/documents/Documents"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute("/beheer/medewerkers/$userId/dossier/")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "employees"),
})

function RouteComponent() {
  const { userId } = useParams({ from: "/beheer/medewerkers/$userId" })

  return <Documents userId={Number(userId)} />
}
